import type { FunctionComponent, ReactNode } from "react";

type Props = {
  children?: ReactNode;
  isRosettaLoading: boolean;
};

export const PlusPaywallSuspenseContent: FunctionComponent<Props> = ({
  children,
  isRosettaLoading,
}) => {
  if (isRosettaLoading) {
    const promise = new Promise(resolve => resolve(isRosettaLoading));
    throw promise;
  } else {
    return children;
  }
};

PlusPaywallSuspenseContent.displayName = "PlusPaywallSuspenseContent";
